export const getNameInitials = (name,initialsLength=4) => {
    try {
        var parts = name.split(' ')
        var initials = ''
        for (var i = 0; i < parts.length; i++) {
            if (parts[i].length > 0 && parts[i] !== '') {
                initials += parts[i][0]
            }
        }
        return initials.substring(0,initialsLength).toUpperCase();
    } catch (e) {
        console.log("Error in generating name initals")
        return name;
    }
}